/* 單獨列傳：太史慈傳（設計見 docs/CAMPAIGN-TAISHICI.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「taishici_」，免得和其他列傳撞名。 */
// @ts-nocheck
import taishici_luoyang from '../maps/taishici_luoyang.ts';
import taishici_jingxian from '../maps/taishici_jingxian.ts';
import taishici1 from '../story/taishici1.ts';
import taishici2 from '../story/taishici2.ts';
import taishici_mabao from '../maps/taishici_mabao.ts';
import taishici3 from '../story/taishici3.ts';
import taishici_haihun from '../maps/taishici_haihun.ts';
import taishici4 from '../story/taishici4.ts';

export default {
  list: { id: 'taishici', name: '太史慈傳', years: '186–206', parts: [
    { name: '青州篇', chapters: ['taishici-1'] },
    { name: '江東篇', chapters: ['taishici-2', 'taishici-3', 'taishici-4'] },
  ] },
  chapters: [taishici1, taishici2, taishici3, taishici4],
  maps: { taishici_luoyang, taishici_jingxian, taishici_mabao, taishici_haihun },
};
